(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('fileScanHistoryConverter', ["$q", "avananModules", "scanStatsParser", "troubleshooting", function ($q, avananModules, scanStatsParser, troubleshooting) {
        return function (input, args) {
            _(avananModules).each(function (avananModule) {
                if (_(args.modules.data.apps_items.modules).chain().find(function (module) {
                        return module.name === avananModule.name;
                    }).isUndefined().value()) {
                    args.modules.data.apps_items.modules.push(avananModule);
                }
            });
            var data = args.lastOnly ? {} : [];
            _(input.data).chain().filter(function (v) {
                return _(v.related_apps).isArray() && v.related_apps.length === 1 && v.history_entities.length;
            }).each(function (v) {
                var found = _(args.modules.data.apps_items.modules).find(function (module) {
                    return module.name == v.related_apps[0] && (!module.gui_hidden || troubleshooting.entityDebugEnabled()) && module.name !== 'cp_capsule' && (module.state === 'active' || troubleshooting.entityDebugEnabled() && module.name === 'solgate');
                });
                if (!found) {
                    return;
                }
                var conf = args.config.data.apps[found.name];
                if (_(conf).isUndefined()) {
                    conf = args.config.data.modules[found.module_name];
                }
                if (!conf) {
                    return;
                }
                var entityData = [];
                _(v.history_entities).each(function (row) {
                    var statistics = scanStatsParser(row, conf.statistics);
                    if (statistics.total_match || statistics.total_unmatch) {
                        row.found = found;
                        row.statistics = statistics;
                        row.isHistory = true;
                        row.av_fd_update_time = row.av_fd_update_time || row.update_time || row.av_update_time;
                        entityData.push(row);
                    }
                });
                if (!entityData.length) {
                    return;
                }
                if (args.lastOnly) {
                    data[found.name] = _(entityData).chain().sortBy('av_fd_update_time').last().value();
                } else {
                    _(entityData).each(function (row) {
                        data.push(row);
                    });
                }
            });
            return $q.when({ data: data });
        };
    }]);
}());